/**
 * Ref-counted body scroll-lock shared by every overlay that suppresses page
 * scrolling (modals, the mobile nav drawer). The count means closing one of
 * several stacked overlays doesn't prematurely unlock the body; the body's
 * inline overflow is captured before the first lock so the last unlock
 * restores it exactly rather than blindly clearing it.
 */
let lockCount = 0;
let savedBodyOverflow = '';

export function lockBodyScroll(): void {
  if (lockCount === 0) {
    savedBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount++;
}

export function unlockBodyScroll(): void {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    if (savedBodyOverflow) {
      document.body.style.overflow = savedBodyOverflow;
    } else {
      document.body.style.removeProperty('overflow');
    }
    savedBodyOverflow = '';
  }
}
